export default __webpack_public_path__ + "img/e5e684964eb5d936086f1c1e2801d918.png";